<template>
  <section class="section-shaped">
    <div :class="'shape bg-'+color+' shape-skew' + (alt ? '-alt':'-norm')"></div>
    <div class="container shape-container d-flex">
      <div class="col justify-content-center text-center px-0 py-sm">
        <div class="row">
          <div class="col-12">
            <img
              :src="'/images/games/appicons/'+projectId+'_appicon.png'"
              :alt="projectName+' Logo'"
              class="col-md-4 col-sm-8"
            >
          </div>
          <div class="col-12" v-if="client">
            <img :src="'/images/games/clientlogos/'+projectId+'_clientlogo.png'">
          </div>
        </div>
        <div class="row p-sm align-items-center">
          <div class="col-md-6 pb-sm">
            <phone :projectId="projectId"></phone>
          </div>
          <div class="col-md-6">
            <h1 class="display-3 text-white d-none">
              {{ projectName }}
              <span class="h5 text-white">{{ client }}</span>
            </h1>
            <h5 class="text-white font-weight-bold text-left">Challenge</h5>
            <p class="text-left text-white">{{ projectChallenge }}</p>
            <h5 class="text-white font-weight-bold text-left pt-4">Solution</h5>
            <p
              class="text-white text-left"
              v-for="(solution, idx) in projectSolutions.split('\n')"
              :key="idx"
            >
              {{ solution }}
              <br>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Phone from "./Phone";
export default {
  components: {
    Phone
  },
  props: {
    projectId: {
      type: String,
      default: ""
    },
    projectName: {
      type: String,
      default: ""
    },
    projectChallenge: {
      type: String,
      default: ""
    },
    projectSolutions: {
      type: String,
      default: ""
    },
    client: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "dark"
    },
    alt: {
      type: Boolean,
      default: false
    }
  }
};
</script>